import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoProvider } from 'src/app/services/grupo/grupo';

@Component({
  selector: 'app-grupo-feedback',
  templateUrl: './grupo-feedback.page.html',
  styleUrls: ['./grupo-feedback.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class GrupoFeedbackPage implements OnInit {
  validations_form: FormGroup;
  validation_messages = {
    'feedback': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ]
  };
  idGrupo: string = '';
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider
  ) {
    this.validations_form = this.formBuilder.group({
      feedback: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?!\s*$).+/)
        ]
      ]
    });
    this.idGrupo = this.navParams.get('idGrupo');
  }

  ngOnInit() { }

  onSubmit(form: { feedback: any; }) {
    this.grupoProvider.criarFeedback({ feedback: form.feedback, idGrupo: this.idGrupo }).subscribe(async data => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Feedback criado com sucesso!'),
        duration: 3000
      });

      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
